import { render, staticRenderFns } from "./CategoryBox.vue?vue&type=template&id=13314eab&scoped=true&"
import script from "./CategoryBox.vue?vue&type=script&lang=js&"
export * from "./CategoryBox.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBox.vue?vue&type=style&index=0&id=13314eab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13314eab",
  null
  
)

export default component.exports